import { useMutation } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { CreateFinanceProfitRequestDTO } from "@/types";

async function createFinanceProfit(request: CreateFinanceProfitRequestDTO) {
  const response = await httpRequest.post("/finance-summary", request);
  return response.data;
}

export function useCreateFinanceProfitMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createFinanceProfit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["finance-summary"] });
    },
  });
}
